// extracted by mini-css-extract-plugin
export default {"root":"ViewTabSection_root__lweEl","appBar1":"ViewTabSection_appBar1__umi1e"};